import { takeLatest, call, put } from 'redux-saga/effects';
import { serializeParams } from 'utils/functions/general';
import { addToast } from 'modules/common/commonSlice';
import { getHealthPlanById } from 'modules/categories/api';
import { getInsuranceCompany, addHealthPlan, getHealthPlans, editHealthPlan } from './api';
import {
  fetchInsuranceFail,
  fetchInsuranceSuccess,
  createHealthPlanSuccess,
  createHealthPlanFail,
  fetchHealthPlansSuccess,
  fetchHealthPlansFail,
  editHealthPlanSuccess,
  editHealthPlanFail,
  fetchSelectedealthPlanFail,
  fetchSelectedealthPlanSuccess,
} from './healthPlansSlice';

function* fetchInsurancsSaga(payload) {
  try {
    const response = yield call(getInsuranceCompany, payload);
    yield put(fetchInsuranceSuccess(response.data.data));
  } catch (error) {
    yield put(fetchInsuranceFail(error));
  }
}

function* createHealthPlanSaga({ payload }) {
  try {
    const response = yield call(addHealthPlan, payload);
    yield put(createHealthPlanSuccess(response.data));
    yield put(addToast({ type: 'success', message: 'Health plan is added successfully' }));
  } catch (error) {
    yield put(createHealthPlanFail());
    yield put(addToast({ type: 'error', message: 'An error occured while adding Health plan' }));
  }
}

function* editHealthPlanSaga({ payload }) {
  try {
    const response = yield call(editHealthPlan, payload);
    yield put(editHealthPlanSuccess(response.data));
    yield put(addToast({ type: 'success', message: 'Health plan edited successfully' }));
  } catch (error) {
    yield put(editHealthPlanFail());
    yield put(addToast({ type: 'error', message: 'An error occured while editing Health plan' }));
  }
}

function* fetchHealthPlansSaga({ payload }) {
  try {
    const queryStringOfObj = serializeParams(payload);
    const response = yield call(getHealthPlans, queryStringOfObj);
    yield put(fetchHealthPlansSuccess(response.data.data));
  } catch (error) {
    yield put(fetchHealthPlansFail(error));
  }
}

function* fetchHealthPlanSaga({ payload }) {
  try {
    const selectedHealthPlanId = payload;
    const response = yield call(getHealthPlanById, selectedHealthPlanId);
    yield put(fetchSelectedealthPlanSuccess(response.data.data));
  } catch (error) {
    yield put(fetchSelectedealthPlanFail(error));
  }
}

function* healthPlansSaga() {
  yield takeLatest('healthPlans/fetchInsurance', fetchInsurancsSaga);
  yield takeLatest('healthPlans/createHealthPlan', createHealthPlanSaga);
  yield takeLatest('healthPlans/fetchHealthPlans', fetchHealthPlansSaga);
  yield takeLatest('healthPlans/editHealthPlan', editHealthPlanSaga);
  yield takeLatest('healthPlans/fetchSelectedealthPlan', fetchHealthPlanSaga);
}

export default healthPlansSaga;
